const get_started = {
    page_title: 'Начало работы',
    title: 'Что-то, что поможет вам добиться успеха',
    subtitle: 'Несколько вещей, которые вы можете сделать, чтобы быстро получить ценность от Logto',
    develop: {
        title: 'Develop: Вам понадобится 5 минут, чтобы интегрировать ваше приложение',
    },
    customize: {
        title: 'Customize: Создайте отличный вариант входа в систему',
        preview: {
            title: 'Проверьте прямую трансляцию присоединения к системе, которое вы только что настроили',
            subtitle: 'Попробуйте пробный вариант входа в систему Logto, чтобы узнать, как это работает',
        },
        connector: {
            title: 'Добавьте больше коннекторов, чтобы поддерживать больше способов входа через социальные сети',
            subtitle: 'Попробуйте вход без пароля и включите защищенный и плавный опыт для ваших клиентов',
        },
        continue_customizing: 'Продолжайте настройку',
        try_now: 'Попробуйте сейчас',
        add_more: 'Добавьте еще',
    },
    secure: {
        title: 'Secure: Защитите свои ресурсы',
    },
    manage: {
        title: 'Manage: Определите контроль доступа для вашего продукта и пользователей',
        rbac: {
            title: 'Добавьте контроль доступа на основе ролей, чтобы защитить ваши ресурсы',
            subtitle: 'Управляйте вашим ресурсом через масштабируемую авторизацию ролей для различных случаев использования',
        },
        create_roles: 'Создать роли',
    },
    view_all: 'Посмотреть все →',
};
export default Object.freeze(get_started);
